import {useRouter} from "next/router";
import {useEffect, useRef, useState} from "react";
import resize from "@FRAMEWORK/utils/partners/resize";
import publicConfig from "@FRAMEWORK/config/public";

const resizeFunction = resize();
const PartnerResizeProvider = ({children}) => {
	const router = useRouter();
	const [size, setSize] = useState(0);
	const script: any = useRef();
	const tick = () => {
		const thisSize = Math.ceil(document.querySelector("#__next")?.getBoundingClientRect().height || 0);
		setSize(thisSize);
	};
	useEffect(() => {
		if (router.pathname.indexOf("gmarket") > 0 || router.query?.$partnerName) {
			if (!script.current) {
				script.current = resizeFunction(router);
			}
			const int = setInterval(tick, 1000);
			return () => clearInterval(int);
		}
	}, [router]);

	useEffect(() => {
		if (size === 0 || publicConfig.RUNTIME_ENV === "local") return;
		typeof script.current === "function" && script.current(size);
	}, [size]);
	return (
		<>
			{children}
			<form id="iframePartnerForm" name="iframePartnerForm" method="get" action="" target="iframePartner">
				<input type="hidden" name="h" />
			</form>
			<iframe id="iframePartner" name="iframePartner" style={{display: "none"}}></iframe>
		</>
	);
};

export default PartnerResizeProvider;
